module.exports = __webpack_public_path__ + "static/media/stofferingen-59.d44436f1.jpg";